export const generateIdForText = (text: string) => {
  const splitted = text.split(' ')
  const firstThreeWords = splitted.slice(0, 3)
  const hypenated = firstThreeWords.join('-')
  const encodedUri = encodeURI(hypenated)
  return encodedUri
}
